import React, { useEffect, useState } from "react";
import { ErrorToaster, SuccessToaster } from "../../../feature-module/components/toaster/Toaster";
import { modalCloseListener } from "../../../utils/helper";
import { Calendar } from "react-feather";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { InputLabel } from "@mui/material";
import InvoiceServices from "../../../services/Invoice";

const ExportInvoices = () => {

	const { RangePicker } = DatePicker;

	const [loading, setLoading] = useState(false);
	const [selectedDateRange, setSelectedDateRange] = useState([dayjs().subtract(1, "month").startOf("month"), dayjs()]);

	// *For Submit Form
	const submitForm = async () => {
		setLoading(true);
		try {
			const params = {
				page: 1,
				limit: 1000,
				from: dayjs(selectedDateRange[0]).format('YYYY-MM-DD'),
				to: dayjs(selectedDateRange[1]).format('YYYY-MM-DD'),
			};
			const response = await InvoiceServices.exportInvoices(params)

			const blobData = response.data || response;
			const url = window.URL.createObjectURL(new Blob([blobData]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `Invoices_${params.from}_to_${params.to}.xlsx`);
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);
			window.URL.revokeObjectURL(url);
			SuccessToaster('Invoices Downloaded Successfully');

			const btn = document.getElementById('close-invoice-export')
			btn.click();
		} catch (error) {
			ErrorToaster('There is no data available for the selected date range to export invoices.');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const cleanup = modalCloseListener("export-modal", () => {
		});

		return cleanup;
	}, []);

	return (
		<div className="modal fade" id="export-modal">
			<div className="modal-dialog modal-dialog-centered custom-modal-two">
				<div className="modal-content">
					<div className="page-wrapper-new p-0">
						<div className="content">
							<div className="modal-header border-0 custom-modal-header">
								<div className="page-title">
									<h4>Export Invoices</h4>
								</div>
								<button
									type="button"
									className="close"
									data-bs-dismiss="modal"
									aria-label="Close"
								>
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body custom-modal-body">
								<div className="row">
									<div className="col-lg-12">
										<div className="input-blocks mb-0">
											<InputLabel sx={{ textTransform: "capitalize", fontSize: "14px", fontWeight: "600", color: "#5b6670" }}>
												Select Date Range
											</InputLabel>
											<div className="input-groupicon calender-input">
												<Calendar className="info-img" />
												<RangePicker
													placement="bottomLeft"
													value={selectedDateRange}
													onChange={(date) => setSelectedDateRange(date)}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="modal-footer-btn">
									<button
										id="close-invoice-export"
										type="button"
										className="btn btn-cancel me-2"
										data-bs-dismiss="modal"
									>
										Cancel
									</button>
									<button
										type="button"
										className="btn btn-submit"
										onClick={() => submitForm()}
										disabled={loading}
									>
										{loading ? 'Downloading...' : 'Download Invoices'}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExportInvoices;
